type Options = {
  /**
   * Follow the link in a new tab.
   *
   * A browser ignores `download` on a cross-origin href, so the click is a real
   * navigation: it downloads only because the server sent
   * `Content-Disposition: attachment`, and anything else — an expired presigned
   * URL, a 403 — replaces this app with the server's error page. Opening in a
   * new tab keeps that failure out of the app; on success the browser closes
   * the new tab itself, since the navigation resolves to a download.
   */
  shouldOpenInNewTab?: boolean;
};

export const downloadFileUsingUrl = (url: string, fileName = '', { shouldOpenInNewTab }: Options = {}) => {
  const element = document.createElement('a');

  element.setAttribute('href', url);
  element.setAttribute('download', fileName);

  if (shouldOpenInNewTab) {
    element.setAttribute('target', '_blank');
    element.setAttribute('rel', 'noopener');
  }

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};
